export const CloudIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.28459 7.49996C5.97098 5.55798 7.82305 4.16663 10.0001 4.16663C12.7615 4.16663 15.0001 6.4052 15.0001 9.16663C16.841 9.16663 18.3334 10.659 18.3334 12.5C18.3334 14.3409 16.841 15.8333 15.0001 15.8333H5.83341C3.53223 15.8333 1.66675 13.9678 1.66675 11.6666C1.66675 9.55746 3.23391 7.8143 5.26732 7.53809"
        stroke="url(#paint0_linear_106_4947)"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_106_4947"
          x1="2.29172"
          y1="8.12476"
          x2="18.5417"
          y2="18.1248"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7647EE" />
          <stop offset="0.442321" stopColor="#F7AD3C" />
          <stop offset="1" stopColor="#F73C3C" />
        </linearGradient>
      </defs>
    </svg>
  );
};
